import { useState, useEffect } from 'react';

const useTransactionHistory = (userType = 'user') => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [error, setError] = useState(null);

  const fetchTransactions = async (page = 1, filters = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      // Remove undefined and empty string values from filters
      const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: '20',
        ...cleanFilters
      });

      let endpoint;
      switch (userType) {
        case 'admin':
          endpoint = `/api/v1/admin/transactions?${queryParams}`;
          break;
        case 'restaurant':
          endpoint = `/api/v1/transactions/restaurant/history?${queryParams}`;
          break;
        default:
          endpoint = `/api/v1/transactions/user/history?${queryParams}`;
      }

      const response = await fetch(`https://mongobyte-hc73.onrender.com${endpoint}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch transactions');
      }

      const data = await response.json();
      console.log(data)
      if (data.success) {
        setTransactions(data.data.transactions);
        setPagination(data.data.pagination);
      } else {
        throw new Error(data.message || 'Failed to fetch transactions');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    transactions,
    loading,
    pagination,
    error,
    fetchTransactions,
    refetch: () => fetchTransactions(pagination.page || 1)
  };
};

export default useTransactionHistory;